function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChiller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    id: "svg843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.16812615,0.04568015)",
    id: "g842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path885",
    d: "M 61.115562,1.3857587 H 78.940621 V 16.598525 H 31.919344 V 23.20609 H 45.749131 V 80.676545 H 2.7231267 V 23.20609 H 17.628564 V 7.5323309 C 18.322083,4.8837769 21.316949,1.8056857 23.9288,1.2320947 h 25.35461",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path887",
    d: "M 29.921708,31.196634 H 40.217216",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path889",
    d: "M 2.5694617,50.097343 H 45.441803",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path891",
    d: "M 45.749131,42.260464 H 78.786956 V 80.522875 H 45.595467",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.7921929,
    cy: 65.156441,
    cx: 23.621473,
    id: "path893",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2.0941,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiller);
export default __webpack_public_path__ + "static/media/chiller.d4a9d33f09814f7ac63c6d299a2bc948.svg";
export { ForwardRef as ReactComponent };